/**
 * Avance de obra (OPUS ci, idea 11 «Avance 4D»): cliente de lectura del avance de la hoja de un plano. Solo staff (la
 * ruta lo exige). Los avances los ENVÍA OPUS 27 (estimaciones) y más adelante el control de obra; aquí solo se leen.
 *
 * Un plano sin hoja o sin avances recibidos responde vacío (`seleccionada: null`), no con error.
 */
import type { LeerAvanceObraResponse, OrigenAvance } from '@supernova/shared';
import { apiFetch } from './client.js';

export async function getAvanceDePlano(
  projectId: string,
  fileId: string,
  opts: { obraRef?: string; origen?: OrigenAvance } = {},
): Promise<LeerAvanceObraResponse> {
  const q = new URLSearchParams();
  if (opts.obraRef) q.set('obraRef', opts.obraRef);
  if (opts.origen) q.set('origen', opts.origen);
  const sufijo = q.toString() ? `?${q.toString()}` : '';
  return await apiFetch<LeerAvanceObraResponse>(`/api/v1/projects/${projectId}/planos/${fileId}/avance${sufijo}`);
}
